import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { academydetail, athletedetail, studentview, teacherview, workerdetail, workerdashboardcount } from "../service/dashboard";
import Footer from "./footer";
import Header from "./header";
import moment from "moment";

const IDCardView = () => {
    const [sdetail, setSDetail] = useState({});
    const [adetail, setADetail] = useState({});

    const [spath, setSPath] = useState("");
    const role = localStorage.getItem("Role");
    const isWorker = role === "6" || role === "9";

    // Field names differ between the student/teacher record and the worker record.
    const displayName = isWorker ? sdetail.worker_name : role === "4" ? sdetail.student_name : sdetail.teacher_name;
    const photoFile = isWorker ? sdetail.worker_photo : sdetail.photo;
    const dob = isWorker ? sdetail.dob : sdetail.date_of_birth;

    useEffect(() => {
        academydetail(localStorage.getItem("academy")).then((res) => {
            if (res.status === true) {
                setADetail(res.data.details);
            }
        })
        if (role === "4") {
            studentview(localStorage.getItem("UID")).then((res) => {
                if (res.status === true) {
                    setSDetail(res.data.details);
                    setSPath(res.data.path);
                }
            });
        } else if (role === "5") {
            teacherview(localStorage.getItem("UID")).then((res) => {
                if (res.status === true) {
                    setSDetail(res.data.details);
                    setSPath(res.data.path);
                }
            })
        } else if (isWorker) {
            // Resolve user_id -> workers.id, then load the full worker record.
            const temp = new FormData();
            temp.append("user_id", localStorage.getItem("UID"));
            temp.append("role_id", role);
            workerdashboardcount(temp).then((wres) => {
                const workerId = wres?.status === true && wres.data.workers ? wres.data.workers.id : null;
                if (!workerId) return;
                workerdetail(workerId).then((res) => {
                    if (res?.status === true) {
                        setSDetail(res.data.details);
                        setSPath(res.data.path);
                    }
                });
            });
        }

    }, [])

    function errorhandle(ev) {
        ev.target.src = require("../assets/images/placeholder.png");
        ev.target.onerror = null;
    }

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="moreheading">
                    <Row className="row-sm">
                        <Col xs={6} className="text-left align-self-end">
                            <h4 className="morehead-text">IDCard</h4>
                        </Col>

                        <Col xs={6} className="text-right align-self-end">
                            <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>
                    </Row>
                </div>
                <div className="id-card">
                    <div className="header">
                        <h3>{adetail.name}</h3>
                    </div>

                    <div className="content">
                        {/* LEFT IMAGE */}
                        <div className="left">
                            <img
                                src={spath + photoFile}
                                onError={errorhandle}
                                alt="student"
                                className="photo"
                            />
                            <p className="photo-text">PHOTO</p>
                        </div>

                        {/* RIGHT DETAILS */}
                        <div className="right">
                            <p><strong>Name:</strong> {displayName}</p>

                            {!isWorker && <p><strong>Father:</strong> {sdetail.father_name}</p>}
                            <p><strong>DOB:</strong> {dob ? moment(dob).format("DD-MM-YYYY") : ''}</p>
                            {!isWorker && <p><strong>Class:</strong> {sdetail.class_name} - {sdetail.section_name}</p>}
                            {role === "4" ? <p><strong>Roll:</strong> {sdetail.roll_number}</p>
                             : isWorker ? <p><strong>Qualification:</strong> {sdetail.qualification}</p>
                             : <p><strong>Qualification:</strong> {sdetail.qual_name}</p>}
                            {isWorker && <p><strong>Employee ID:</strong> {sdetail.employee_id}</p>}


                            <p><strong>Mobile:</strong> {sdetail.phone}</p>
                            {/* <p><strong>Email:</strong> {sdetail.parent_email}</p> */}
                        </div>
                    </div>

                    <div className="footer">
                        {adetail.address} | {adetail.phone} | {adetail.email}
                    </div>
                </div>
                <div className="id-card back mt-2">
                    <div className="header">
                        <h3>{adetail.name}</h3>
                    </div>

                    <div className="content-back">
                        <p><strong>Address:</strong></p>
                        <p className="address">
                            {sdetail.address1} <br />
                            {sdetail.city}, {sdetail.district} <br />
                            {sdetail.pincode}
                        </p>

                        <div className="extra">
                            <p><strong>Blood Group:</strong> {sdetail.blood_name}</p>
                        </div>
                    </div>

                    <div className="footer">
                        <p>If found, please return to school office</p>
                    </div>
                </div>

            </div>

            <Footer />
        </div>
    );
};

export default IDCardView;
